'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { merge } from 'rxjs/observable/merge';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { INITIALIZED_HEADER_DETAILS_SIDEBAR } from '../actions/ActionTypes';
import { receiveForms, requestedFormsFailed, requestForms } from '../actions/FormsActions';
import { receiveSpecificLists, requestedSpecificListsFailed, requestSpecificLists } from '../actions/ListsActions';
import { receiveStylesheets, requestedStylesheetsFailed, requestStylesheets } from '../actions/StylesheetsActions';
import { receiveTemplate, requestedTemplateFailed, requestTemplate } from '../actions/TemplateActions';
export default ((action$, _, {
  FormsClient,
  ListsClient,
  StylesheetsClient,
  TemplateClient
}) => action$.ofType(INITIALIZED_HEADER_DETAILS_SIDEBAR).pipe(mergeMap(({
  payload: {
    contentType,
    id,
    layoutId,
    listIds,
    templatePath
  }
}) => merge(FormsClient.fetchFormsForPage(id).pipe(map(receiveForms), catchError(error => of(requestedFormsFailed(error))), startWith(requestForms())), StylesheetsClient.fetchStylesheets(contentType, id).pipe(map(receiveStylesheets), catchError(error => of(requestedStylesheetsFailed(error))), startWith(requestStylesheets())), TemplateClient.fetchTemplate(contentType, id, layoutId, templatePath).pipe(map(receiveTemplate), catchError(error => of(requestedTemplateFailed(error))), startWith(requestTemplate())), ListsClient.fetchSpecificLists(listIds).pipe(map(receiveSpecificLists), catchError(error => of(requestedSpecificListsFailed(error))), startWith(requestSpecificLists()))))));